import { forwardRef, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';

import { shakeAnimation } from '../../styles/commonStyle';

interface Props {
  error: string;
  topOffset?: number;
}
export const StyledError = forwardRef<{ shakeError: () => void }, Props>(
  ({ error, topOffset = 54 }: Props, ref) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const replayShakeAnimation = () => {
      wrapperRef.current && (wrapperRef.current.style.animation = 'none');
      setTimeout(() => {
        wrapperRef.current && (wrapperRef.current.style.animation = '');
      }, 0);
    };
    useImperativeHandle(ref, () => ({
      shakeError() {
        replayShakeAnimation();
      },
    }));
    return (
      <StyledErrorWrapper topOffset={topOffset} ref={wrapperRef}>
        {error}
      </StyledErrorWrapper>
    );
  },
);

export const StyledErrorWrapper = styled.div<{ topOffset: number }>`
  z-index: 100;
  background: red;
  color: white;
  text-align: left;
  position: absolute;
  top: ${({ topOffset }) => topOffset}px;
  padding: 6px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 10px;
  letter-spacing: 0.4px;
  ${shakeAnimation}
  animation: shake 0.5s;
`;
